import type { WidgetModule } from "@nexus/widget-sdk";
import { createIndicator, type MetricIndicatorConfig } from "@nexus/widget-kit";

/**
 * The generic metric tile: any metric of any `report-metrics` source, chosen in
 * the editor. Domain dashboards use their domain's indicator instead
 * (`ip-blocking-indicator`, `piracy-audience-indicator`…), the same component
 * with its source fixed; this one stays for sources without a domain indicator
 * and for the dashboards that already place it.
 */
export {
  formatMetricPeriod,
  formatMetricValue,
  getMetricTrend,
  INDICATOR_LABELS as LABELS,
  type MetricTrend,
  type TrendDirection,
  type TrendPolarity,
} from "@nexus/widget-kit";

export type MetricKpiConfig = MetricIndicatorConfig;

const indicator = createIndicator({
  id: "metric-kpi",
  name: "Metric KPI",
  description:
    "One large metric with a customizable title, a comparison trend and explicit unavailable states.",
  version: "2.0.0",
  source: "live-kpi-metrics",
});

export const { manifest, Component, defaultConfig, settings } = indicator;

const widgetModule: WidgetModule<MetricKpiConfig> = indicator;
export default widgetModule;
